var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fes2wbelta)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#2qhmit3dmb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.067A7.167 7.167 0 1 0 8 15.4 7.167 7.167 0 0 0 8 1.067z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98 1.29a.5.5 0 0 0-.625-.78L1.688 1.842a.5.5 0 1 0 .625.78L3.98 1.29zM12.646.51a.5.5 0 0 0-.624.78l1.666 1.334a.5.5 0 0 0 .625-.781L12.646.509z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 .567a7.634 7.634 0 0 0-3.461.824A1 1 0 0 0 3.043.119l.3.376-.3-.376-1.667 1.333a1 1 0 0 0 .831 1.76 7.667 7.667 0 1 0 11.587 0 1 1 0 0 0 .831-1.76L12.96.12a1 1 0 0 0-1.496 1.272A7.635 7.635 0 0 0 8 .567z",
    stroke: "url(#c01gykv9ac)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#u52slnprqd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.501 5.566a.5.5 0 1 0-1 0V8.37a.833.833 0 0 1-.227.572l-.97 1.029a.5.5 0 0 0 .728.686l.97-1.029c.32-.34.5-.79.5-1.258V5.566z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2qhmit3dmb",
    x: -24.166,
    y: -24.6,
    width: 64.334,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_400_1617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_400_1617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u52slnprqd",
    x: 3.168,
    y: 2.066,
    width: 18.334,
    height: 21.748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_400_1617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_400_1617",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c01gykv9ac",
    x1: 0.834,
    y1: 0.4,
    x2: 15.825,
    y2: 14.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fes2wbelta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/Clock2.b14deddf20f80e556ac31b94f4ca96f8.svg";
export { ForwardRef as ReactComponent };